import Image from 'next/image'

import { BiCommentDetail } from 'react-icons/bi'
import { SquircleAdapter } from '../SquircleAdapter'

import './styles.scss'

export interface ICommentProps {
  name: string
  photoUrl: string
  text: string
  date: Date
  style?: React.CSSProperties
}

const Comment = ({ name, text, photoUrl, style }: ICommentProps) => (
  <SquircleAdapter
    className="comment-container"
    cornerRadius={16}
    style={style}
  >
    <div className="header">
      <div>
        <Image
          alt={`Foto de ${name}, cliente da Sancta Fatia`}
          src={photoUrl}
          width={100}
          height={100}
          quality={85}
          priority
        />
        <p className="comment-container__author">{name}</p>
      </div>

      <BiCommentDetail size={16} aria-hidden />
    </div>
    <p>{text}</p>
  </SquircleAdapter>
)

export { Comment }
